import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import { failedIcon } from "@/assets/default-icons";
import { StatusPage } from "@/components/status-page";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/locales/i18n-provider";

export default function ErrorBoundary() {
  const error = useRouteError();
  const { t } = useI18n();
  const description = isRouteErrorResponse(error) ? t("route.error.statusDescription", { status: error.status }) : t("route.error.description");

  return (
    <StatusPage
      actions={<Button onClick={() => window.location.reload()}>{t("route.error.reload")}</Button>}
      description={description}
      illustration={failedIcon}
      title={t("route.error.title")}
    />
  );
}
